<template>
  <div class="updates">
    <ul class="updates__list">
      <li class="updates__item" v-for="update in updates" :key="update.id">
        <div class="updates__date">
          <span class="updates__is-new" v-if="update.isNew">
            New!
          </span>
          <r-text type="caption">
            {{ update.date }}
          </r-text>
        </div>
        <div class="updates__name">
          <r-text> Обновление {{ update.version }} </r-text>
        </div>
        <div class="updates__image">
          <div class="updates__image-content">
            <div class="updates__image-text patch">
              NEW PATCH RELEASE
            </div>
            <div class="updates__image-text version">
              RITM {{ update.version }} {{ update.versionName }}
            </div>
          </div>
          <img
            src="../../assets/images/updates/0-9-talpa.gif"
            :alt="`Обновление ${update.version}`"
          />
        </div>
        <div class="updates__description">
          <r-text>
            {{ update.description }}
          </r-text>
        </div>
        <a :href="update.link" target="_blank" class="updates__link">
          Подробнее о последних обновлениях
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
const updates = [
  {
    id: 1,
    isNew: true,
    date: "30 января 2020",
    version: "0.9",
    versionName: "Talpa",
    link: "https://doc.ritm3.ru/obnovleniya",
    description:
      "Обновленная иерархия модулей и их компонентов. Новый модуль Ситуационный центр."
  }
  // {
  //   id: 2,
  //   isNew: false,
  //   date: "07 октября 2019",
  //   version: "0.8",
  //   versionName: "Sorex",
  //   link:
  //     "https://confluence.apluss.ru/display/ritmdocs/2019.10.07+-+v+0.8+RITM",
  //   description:
  //     "В новом релизе представлен светлый режим системы, который поможет взглянуть на продукт по-новому. А после проведения первого usabiblity-тестирования система стала еще удобнее."
  // }
];

export default {
  data() {
    return {
      updates
    };
  }
};
</script>

<style lang="scss">
.updates {
  width: 420px;

  &__item {
    &:not(:first-child) {
      margin-top: 32px;
    }
  }

  &__date {
    display: flex;
    align-items: center;
  }

  &__is-new {
    color: var(--accent_success);
    text-transform: uppercase;
    font-weight: 100;
    margin-right: 8px;
  }

  &__name {
    margin-top: 8px;
  }

  &__image {
    margin: 16px 0;
    position: relative;

    &-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      padding: 16px;
      background-color: var(--bg_panel_primary) !important;
    }

    &-text {
      letter-spacing: 0.8px;
      text-align: center;
      color: var(--text_secondary) !important;

      &.patch {
        font-size: 12px;
      }

      &.version {
        font-size: 24px;
        margin-top: 16px;
      }
    }

    & > img {
      width: 100%;
      height: auto;
      border-radius: var(--border-radius);
    }
  }

  &__description {
    line-height: 16px;
    word-break: break-word;
  }

  &__link {
    display: block;
    font-size: 12px;
    margin-top: 16px;
    color: var(--accent_primary);
    cursor: pointer;
  }
}
</style>
